import { render } from "./CompanyOverview.vue?vue&type=template&id=0aee78fa&scoped=true"
import script from "./CompanyOverview.vue?vue&type=script&lang=js"
export * from "./CompanyOverview.vue?vue&type=script&lang=js"

import "./CompanyOverview.vue?vue&type=style&index=0&id=0aee78fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee78fa"]])

export default __exports__